import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const PICKUP_ACTIVITY_URL = `${API_HOST}/api/pickupActivity`;

function* createPickupActivity() {
  yield takeEvery(actions.CREATE_PICKUP_ACTIVITY, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/pickupActivity`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_PICKUP_ACTIVITY_ENDED });
    }
  });
}

function* searchPickupActivities() {
  yield takeEvery(actions.SEARCH_PICKUP_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/pickupActivity?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PICKUP_ACTIVITIES_ENDED });
    }
  });
}

function* findPickupActivity() {
  yield takeEvery(actions.FIND_PICKUP_ACTIVITY, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/pickupActivity/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_PICKUP_ACTIVITY_ENDED });
    }
  });
}

function* updatePickupActivity() {
  yield takeEvery(actions.UPDATE_PICKUP_ACTIVITY, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/pickupActivity`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_PICKUP_ACTIVITY_ENDED });
    }
  });
}

function* deletePickupActivities() {
  yield takeEvery(actions.DELETE_PICKUP_ACTIVITIES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/pickupActivity`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_PICKUP_ACTIVITIES_ENDED });
    }
  });
}

function* searchPickupActivityTransactionRecords() {
  yield takeEvery(actions.SEARCH_PICKUP_ACTIVITY_TRANSACTION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/pickupActivity/record?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PICKUP_ACTIVITY_TRANSACTION_RECORDS_ENDED });
    }
  });
}

function* searchPickupCodeBatch() {
  yield takeEvery(actions.SEARCH_PICKUP_CODE_BATCH, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/pickupActivity/issuePickupCode/batch?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PICKUP_CODE_BATCH_ENDED });
    }
  });
}

function* searchPickupCodeBatchRow() {
  yield takeEvery(actions.SEARCH_PICKUP_CODE_BATCH_ROW, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/pickupActivity/issuePickupCode/batch/row?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PICKUP_CODE_BATCH_ROW_ENDED });
    }
  });
}

function* issuePickupActivityPickupCode() {
  yield takeEvery(actions.ISSUE_PICKUP_ACTIVITY_PICKUP_CODE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/pickupActivity/issuePickupCode/batch`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.ISSUE_PICKUP_ACTIVITY_PICKUP_CODE_ENDED });
    }
  });
}

function* invalidatePickupCodesBatch() {
  yield takeEvery(actions.INVALIDATE_PICKUP_CODES_BATCH, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${API_HOST}/api/pickupActivity/issuePickupCode/batch`,
        { data },
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.INVALIDATE_PICKUP_CODES_BATCH_ENDED });
    }
  });
}

function* invalidatePickupCodesBatchRow() {
  yield takeEvery(actions.INVALIDATE_PICKUP_CODES_BATCH_ROW, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${API_HOST}/api/pickupActivity/issuePickupCode/batch/row`,
        { data },
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.INVALIDATE_PICKUP_CODES_BATCH_ROW_ENDED });
    }
  });
}

function* pickupActivity() {
  yield takeEvery(actions.PICKUP_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/pickupActivity/pickup`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.PICKUP_ACTIVITY_ENDED });
    }
  });
}

function* getPickupActivityStatistics() {
  yield takeEvery(actions.GET_PICKUP_ACTIVITY_STATISTICS, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/pickupActivity/statistics/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_PICKUP_ACTIVITY_STATISTICS_ENDED });
    }
  });
}

function* searchPickupActivityCategories() {
  yield takeEvery(actions.SEARCH_PICKUP_ACTIVITY_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/pickupActivity/pickupActivityCategory/?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_PICKUP_ACTIVITY_CATEGORIES_END });
    }
  });
}

function* createPickupActivityCategory() {
  yield takeEvery(actions.CREATE_PICKUP_ACTIVITY_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/pickupActivity/pickupActivityCategory`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_PICKUP_ACTIVITY_CATEGORY_END });
    }
  });
}

function* updatePickupActivityCategory() {
  yield takeEvery(actions.UPDATE_PICKUP_ACTIVITY_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${API_HOST}/api/pickupActivity/pickupActivityCategory`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_PICKUP_ACTIVITY_CATEGORY_ENDED });
    }
  });
}

function* deleteBrandCategories() {
  yield takeEvery(actions.DELETE_PICKUP_ACTIVITY_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${API_HOST}/api/pickupActivity/pickupActivityCategory`,
        { data: formData },
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_PICKUP_ACTIVITY_CATEGORIES_ENDED });
    }
  });
}

function* searchMemberTicketIssuedAndActivities() {
  yield takeEvery(actions.SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      let activitiesData = [];
      const { data } = yield call(
        [axios, 'get'],
        `${PICKUP_ACTIVITY_URL}/report/memberTicketIssued?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, data, activitiesData);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({
        type: actions.SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES_ENDED,
      });
    }
  });
}

function* searchMemberTicketDetailsAndActivities() {
  yield takeEvery(actions.SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      let activitiesData = [];
      const { data } = yield call(
        [axios, 'get'],
        `${PICKUP_ACTIVITY_URL}/report/memberTicketIssuedDetail?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, data, activitiesData);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({
        type: actions.SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES_ENDED,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchPickupActivities),
    fork(createPickupActivity),
    fork(findPickupActivity),
    fork(updatePickupActivity),
    fork(deletePickupActivities),
    fork(searchPickupActivityTransactionRecords),
    fork(searchPickupCodeBatch),
    fork(searchPickupCodeBatchRow),
    fork(issuePickupActivityPickupCode),
    fork(invalidatePickupCodesBatch),
    fork(invalidatePickupCodesBatchRow),
    fork(pickupActivity),
    fork(getPickupActivityStatistics),
    fork(searchPickupActivityCategories),
    fork(createPickupActivityCategory),
    fork(updatePickupActivityCategory),
    fork(deleteBrandCategories),
    fork(searchMemberTicketIssuedAndActivities),
    fork(searchMemberTicketDetailsAndActivities),
  ]);
}
